<script>
import FormCreator from '../UI/Form/FormCreator.vue'
import BlockContent from '../UI/Content/BlockContent.vue'
import FieldCreator from '../UI/Form/FieldCreator.vue'
import EquipmentList from '../Equipment/EquipmentList.vue'
import AddDocumentButtonAndModal from '../Document/AddDocumentButtonAndModal.vue'
import ServiceList from '../Service/ServiceList.vue'
import CommissionList from '../Finance/CommissionList.vue'
import mixinComponent from '../../Mixins/mixinComponent'
import { globalVariablesMixin } from '../../Mixins/global'
import ContractPurchaseOrderList from './ContractPurchaseOrderList.vue'

export default {
  components: {
    ContractPurchaseOrderList,
    AddDocumentButtonAndModal,
    BlockContent,
    CommissionList,
    EquipmentList,
    FieldCreator,
    FormCreator,
    ServiceList,
  },
  mixins: [mixinComponent, globalVariablesMixin],

  props: {
    contract: { type: Object, required: true },
    def: { type: Object, required: true },
  },

  data() {
    return {
      sending: false,
      loading: false,
      loadField: false,
      formData: null,
    }
  },

  computed: {
    canSeeListService() {
      if (user.isReadOnly && conf.services && this.contract?.finance?.services?.length > 0) {
        return true
      } else if (!user.isReadOnly && conf.services && this.contract.finance) {
        return true
      }

      return false
    },
    serviceListContainerClass() {
      return {
        row: true,
        'd-none': !this.canSeeListService,
      }
    },
    canSeeListCommission() {
      if (
        user.isReadOnly &&
        conf.commissions &&
        this.contract?.finance?.commissions?.length > 0 &&
        !this.hasRole('ROLE_PROFITABILITY_SHOW')
      ) {
        return true
      } else if (
        !user.isReadOnly &&
        conf.commissions &&
        this.contract.finance &&
        !this.hasRole('ROLE_PROFITABILITY_SHOW')
      ) {
        return true
      }

      return false
    },
    displayServices() {
      return this.contract.finance.services.filter(
        (service) => service.serviceType.serviceCategory.display === true && service.active === true,
      )
    },
  },

  methods: {
    updateData(newData) {
      this.formData = newData
    },
    globalBuild({ build }) {
      this.loadField = build
    },
    objectReturn({ sending, object }) {
      this.sending = sending
      if (object) {
        this.$emit('set-contract', object)
      }
    },
    equipmentSent(e) {
      if (e.id === this.contract.finance.equipment.id) {
        this.contract.finance.equipment = e
      } else {
        let equipmentIndex = this.contract.finance.equipment.equipments.findIndex((eq) => eq.id === e.id)
        if (equipmentIndex === -1) {
          this.contract.finance.equipment.equipments.push(e)
        } else {
          this.contract.finance.equipment.equipments.splice(equipmentIndex, 1, e)
        }
      }

      this.reloadData()
    },
    reloadData() {
      this.$emit('reload-data')
    },
    quantityService() {
      let quantity = 1
      if (this.contract?.finance?.equipment?.equipments?.length > 0) {
        quantity += this.contract.finance.equipment.equipments.length
      }
      return quantity
    },
    servicesSent(services) {
      this.contract.finance.services = services
    },
    commissionsSent(c) {
      this.contract.finance.commissions = c
    },
    afterUpload(document) {
      if (['equipment_import', 'service_import'].includes(document.documentType.internalName)) {
        location.reload()
      }
    },
    removeService(service) {
      this.contract.finance.services = this.contract.finance.services.filter(({ id }) => id !== service.id)
    },
    getTotalAmounts() {
      return {
        totalAmountOrderedSupplier: this.contract.totalAmountOrderedSupplier,
        totalAmountToOrderSupplier: this.contract.totalAmountToOrderSupplier,
        totalAmountDeliveredSupplier: this.contract.totalAmountDeliveredSupplier,
        totalAmountToDeliverSupplier: this.contract.totalAmountToDeliverSupplier,
        totalAmountAvailable: this.contract.totalAmountAvailable,
        totalContract: this.contract.finance.amount,
      }
    },
  },
}
</script>
<template>
  <div id="activeAndServices">
    <FormCreator
      @update-data="updateData"
      ref="formservice"
      endpoint="contracts"
      method="patch"
      :id="contract.id"
      :config-def="def"
      :config-object="contract"
      dynamic
      class-to-add="d-none"
      @global-build="globalBuild"
      @object-return="objectReturn"
    />

    <div class="row" v-if="contract && loadField">
      <div class="col-md-12">
        <BlockContent color="info" inner-bloc-class="border-contract-blue" e2e-block="equipmentList">
          <template #header-title>
            <div class="row">
              <div class="col-md-5">
                <h5 class="text-info">{{ $t('contract.list.table.equipment_detail') }}</h5>
              </div>
              <div class="col-md-7">
                <FieldCreator
                  :form-data="formData"
                  name="deliveryAt"
                  form-ref="formservice"
                  domain="contract"
                  refresh
                  label-left-equal
                />
              </div>
            </div>
          </template>
          <EquipmentList
            context="contract"
            :main-equipment="contract.finance.equipment"
            :equipments="contract.finance.equipment.equipments"
            :platform-param-id="contract.platformParam?.id"
            :platform-id="contract.companyEntityId"
            :total="contract.finance.simulationAmount"
            :outstanding="contract.finance.outstanding"
            :max-rent="contract.rentInfo.amount"
            :suppliers="def.supplier"
            @equipment-sent="equipmentSent"
            @equipment-deleted="reloadData"
          />
          <div v-if="!user.isReadOnly && hasRole('ROLE_MODEL_AND_IMPORT_SHOW')" class="row justify-content-center">
            <AddDocumentButtonAndModal
              id="equipment"
              context="Contract"
              :context-id="contract.id"
              internalname="equipment_import"
              @document-uploaded="afterUpload"
            />
          </div>
        </BlockContent>
      </div>
    </div>

    <div class="row" :class="serviceListContainerClass">
      <div class="col-md-12">
        <BlockContent
          v-if="contract.finance?.equipment?.productType?.hasServices"
          title-t="service.title"
          title-level="5"
          color="info"
          inner-bloc-class="border-contract-blue"
          e2e-block="serviceList"
        >
          <ServiceList
            :contract-id="contract.id"
            :contract-number="contract.number"
            :finance-id="contract.finance.id"
            :services="displayServices"
            :quantity="quantityService()"
            :readonly="!hasRole('ROLE_EDIT_CONTRACT_SERVICES')"
            @services-sent="servicesSent"
            @service-removed="removeService"
          />
          <div v-if="!user.isReadOnly && hasRole('ROLE_MODEL_AND_IMPORT_SHOW')" class="row justify-content-center">
            <AddDocumentButtonAndModal
              id="service"
              context="Contract"
              :context-id="contract.id"
              internalname="service_import"
              @document-uploaded="afterUpload"
            />
          </div>
        </BlockContent>
      </div>
    </div>

    <div class="row" v-if="canSeeListCommission">
      <div class="col-md-12">
        <BlockContent
          title-t="commission.title"
          title-level="5"
          color="info"
          inner-bloc-class="border-contract-blue"
          e2e-block="commissionList"
        >
          <CommissionList
            ref="commissions"
            :finance-id="contract.finance.id"
            :commissions="contract.finance.commissions"
            @commissions-sent="commissionsSent"
          />
        </BlockContent>
      </div>
    </div>
    <div
      class="row"
      v-if="contract.supplierPurchaseOrders?.length > 0 && (conf.theme_dir === 'ciscar' || conf.theme_dir === 'olinn')"
    >
      <div class="col-md-12">
        <BlockContent
          title-t="purchaseOrder.title"
          title-level="5"
          color="info"
          inner-bloc-class="border-contract-blue"
          e2e-block="purchaseOrderList"
        >
          <ContractPurchaseOrderList
            ref="purchaseorders"
            :purchaseorders="contract.supplierPurchaseOrders"
            :total-amounts="getTotalAmounts()"
            @purchase-sent="reloadData"
            @purchase-canceled="reloadData"
            @message-sent="reloadData"
          />
        </BlockContent>
      </div>
    </div>
  </div>
</template>
